module.exports = __webpack_public_path__ + "img/collection-memoireRingsWhite.9128432.jpg";